module.exports = __webpack_public_path__ + "static/media/ot_1.c3a2b082.JPG";